import { atom } from 'recoil'

export const pageState = atom({
  key: 'smsQuesuePageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    idSms: 0,
    idInvio: 0,
    idConfiguration: 0,
    exitPage: false,
    Items: []
  }
})

export const pageDataState = atom({
  key: 'smsQuesuePageDataState',
  default: {
    Items: [],
    TotalCredits: null,
    SendingsTotalCost: null,
    CountRecipientsToBeQueued: null,
    RecipientsReachedWithoutAlias: null
  }
})

export const progressBarState = atom({
  key: 'smsprogressBarState',
  default: {
    queueStatus: 'ToExecute',
    variant: '',
    queuedPercentage: 0,
    toBeQueued: 0,
    processGlobalStatus: undefined
  }
})

export const modalWarningAliasState = atom({
  key: 'smsmodalWarningAliasState',
  default: {
    show: false,
    sendingType: ''
  }
})
